import {useTranslation} from 'react-i18next';
import {Colors} from '@constants/colors.constants';
import {ArcElement, Chart as ChartJS, Legend, Tooltip} from 'chart.js';
import {CircularProgress, Stack, Typography} from '@mui/material';
import React from 'react';
import {useObservable} from '@ngneat/react-rxjs';
import {statisticsQuery} from '@store/statistics';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import {Pie} from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip, Legend);
ChartJS.register(ChartDataLabels);

const ValoWeightByWasteFamilyChart = () => {
  const {t} = useTranslation();
  const [{valoWeightByWasteFamily, loading}] = useObservable(statisticsQuery.valoWeightByWasteFamily$);

  const sum = valoWeightByWasteFamily?.reduce((acc, val) => acc + val.weight, 0) || 1;
  return (
    <Stack
      height="500px"
      bgcolor={Colors.white}
      borderRadius="4px"
      px="3px"
      py="20px"
      justifyContent="space-between"
    >
      <Typography fontSize={18} fontWeight="700" ml="17px">
        {t('dashboard.statistics.finance.valoByWasteFamily.title')}
      </Typography>
      {loading && <CircularProgress size={30}/>}
      {!loading && <Stack
          height="400px"
      >
          <Pie
              options={{
                cutout: '0%',
                maintainAspectRatio: false,
                responsive: true,
                offset: 10,
                plugins: {
                  tooltip: {
                    backgroundColor: Colors.background,
                    bodyColor: 'black',
                    cornerRadius: 0,
                    caretSize: 0,
                    bodyAlign: 'right',
                    bodySpacing: 5,
                    displayColors: false,
                    callbacks: {
                      label: (el) => {
                        return `${el.label} : ${el.parsed.toFixed(2)}T`;
                      },
                    },
                    bodyFont: {
                      weight: 'bold',
                      size: 14,
                    },
                  },
                  datalabels: {
                    display: true,
                    anchor: 'center',
                    align: 'center',
                    color: 'white',
                    formatter: function (value) {
                      return ((value / sum) * 100).toFixed(2) + '%';
                    },
                    textStrokeColor: 'black',
                    textStrokeWidth: 2,
                    font: {
                      family: 'CircularStd, sans-serif',
                      size: 14,
                      weight: 'bold'
                    },
                  },
                  legend: {
                    display: true,
                    position: 'left',
                    labels: {
                      font: {
                        family: 'CircularStd, sans-serif',
                        size: 14,
                      },
                    }
                  },
                  title: {display: false},
                },
              }}
              plugins={[ChartDataLabels]}
              data={{
                labels: valoWeightByWasteFamily?.map((v) => v.wasteFamilyName) || [],
                datasets: [
                  {
                    data: valoWeightByWasteFamily?.map((v) => v.weight) || [],
                    backgroundColor: [Colors.warning, Colors.info, Colors.yellow, Colors.pink, Colors.success, Colors.error, Colors.blue],
                  }
                ]
              }}
          /> </Stack>}
    </Stack>
  );
};

export default ValoWeightByWasteFamilyChart;
